module.exports = __webpack_public_path__ + "assets/media/card-img-personalized-videos.fc55818f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/VideoInstallStep/assets/card-img-personalized-videos.jpg
// module id = 3249
// module chunks = 0